import { render, staticRenderFns } from "./BoxIcon.vue?vue&type=template&id=159e01a6&scoped=true&"
import script from "./BoxIcon.vue?vue&type=script&lang=js&"
export * from "./BoxIcon.vue?vue&type=script&lang=js&"
import style0 from "./BoxIcon.vue?vue&type=style&index=0&id=159e01a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159e01a6",
  null
  
)

export default component.exports